import { render } from "./Chart-doughnut-legend-card.vue?vue&type=template&id=14295d1b"
import script from "./Chart-doughnut-legend-card.vue?vue&type=script&lang=js"
export * from "./Chart-doughnut-legend-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/charts/Chart-doughnut-legend-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14295d1b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14295d1b', __exports__)) {
    api.reload('14295d1b', __exports__)
  }
  
  module.hot.accept("./Chart-doughnut-legend-card.vue?vue&type=template&id=14295d1b", () => {
    api.rerender('14295d1b', render)
  })

}


export default __exports__